import React from 'react';
import { PropTypes } from 'prop-types';
import * as Yup from 'yup';
import { useApolloClient } from '@apollo/client';
import { useRenameJobMutation } from 'behaviour/jobs';
import { TextEditor } from 'components/form/editors/';
import { Modal } from 'components/modal';
import { createUniqueJobValidator, createValidJobNameValidator } from 'behaviour/jobs/validators';
import { extendSchema } from 'util/yup';

function RenameJobDialog({
  name,
  open,
  setOpen,
  onRenamed,
}) {
  const apollo = useApolloClient();
  const renameJob = useRenameJobMutation();

  const validationSchema = Yup.object().shape({
    newName: extendSchema(Yup.string()
      .required()
      .notOneOf([name], 'New project name is the same as the current one. Choose different name'),
      [
        createValidJobNameValidator,
        schema => createUniqueJobValidator(schema, apollo),
      ]),
  });

  const handleSubmit = (values, { setSubmitting }) => {
    renameJob(name, values.newName)
      .then((result) => {
        if (result && result.data && onRenamed) {
          setOpen(false);
          onRenamed(name, values.newName);
        }
      }).finally(() => setSubmitting(false));
  };

  return (
    <>
      <Modal
        heading="Rename project"
        open={open}
        onClose={() => setOpen(false)}
        actionsProps={[{
          className: 'cancelButton',
          onClick: () => setOpen(false),
          text: 'Cancel',
        }, {
          className: 'renameButton',
          type: 'submit',
          text: 'Rename',
        }]}
        formProps={{
          initialValues: { newName: name },
          validationSchema,
          validateOnChange: false,
          onSubmit: handleSubmit,
        }}
      >
        <TextEditor
          name="newName"
          label="New project name"
          fullWidth
          autoFocus
        />
      </Modal>
    </>
  );
}

export default RenameJobDialog;

RenameJobDialog.propTypes = {
  name: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  onRenamed: PropTypes.func,
};
